import { v4 as uuidv4 } from 'uuid'

// Chave do header `Idempotency-Key` (uuid v4). Gere UMA por intenção de envio e reaproveite-a nas
// novas tentativas do mesmo envio (erro de rede, timeout, "Tentar novamente"): o servidor devolve o
// resultado já gravado em vez de criar um segundo registro. O Report de Momento X usa uma chave por
// rascunho (o compromisso só pode ter um report; qualquer reenvio dele é o mesmo envio).
export const IDEMPOTENCY_HEADER = 'Idempotency-Key'

const hex = byte => byte.toString(16).padStart(2, '0')

/** uuid v4 a partir de `crypto.getRandomValues` (RFC 4122); sem Web Crypto, cai na lib `uuid`. */
export const newIdempotencyKey = () => {
  const cryptoApi = typeof window !== 'undefined' ? (window.crypto || window.msCrypto) : undefined
  if (!cryptoApi || typeof cryptoApi.getRandomValues !== 'function') return uuidv4()

  const bytes = cryptoApi.getRandomValues(new Uint8Array(16))
  /* eslint-disable no-bitwise */
  bytes[6] = (bytes[6] & 0x0f) | 0x40 // versão 4
  bytes[8] = (bytes[8] & 0x3f) | 0x80 // variante RFC 4122
  /* eslint-enable no-bitwise */
  const digits = Array.from(bytes, hex).join('')

  return [
    digits.slice(0, 8),
    digits.slice(8, 12),
    digits.slice(12, 16),
    digits.slice(16, 20),
    digits.slice(20),
  ].join('-')
}
